import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const CompanyModule = lazy(loadModule);

export default CompanyModule;
